/**
 * Shared option lists for the directory and the consumer-facing pages.
 *
 * Directory.js still declares its own copies of PA_OPTIONS / PA_TAG_CLASS /
 * VERIFIED_HINT. That file is being changed in an open PR, so it is left alone
 * here to avoid a merge conflict — fold it onto this module once that lands.
 */

export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
  "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia",
  "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
  "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
  "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
  "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
  "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
  "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming",
];

export const PA_OPTIONS = [
  "Civil Litigation",
  "Business / Corporate / Contracts",
  "Labor & Employment",
  "Criminal Defense / Post-Conviction",
  "Personal Injury / Insurance",
  "Family Law",
  "Estate Planning / Probate",
  "Immigration",
  "Real Estate / Construction",
  "Bankruptcy / Debt Relief",
];

export const PA_TAG_CLASS = {
  "Civil Litigation": "pa-litigation",
  "Business / Corporate / Contracts": "pa-business",
  "Labor & Employment": "pa-employment",
  "Criminal Defense / Post-Conviction": "pa-criminal",
  "Personal Injury / Insurance": "pa-injury",
  "Family Law": "pa-family",
  "Estate Planning / Probate": "pa-estate",
  Immigration: "pa-immigration",
  "Real Estate / Construction": "pa-realestate",
  "Bankruptcy / Debt Relief": "pa-bankruptcy",
};

export const VERIFIED_HINT =
  "Confirmed by LawFusion — not a check of bar license or credentials.";

/** Where the consumer page stores the visitor's chosen state. */
export const STATE_STORAGE_KEY = "lawfusion.usState";

/**
 * Plain-language description of what falls under each practice area, shown
 * behind the +/- expander on the consumer practice-area filter so a visitor
 * who does not know the legal label can still recognise their own problem.
 */
export const PA_DETAILS = {
  "Civil Litigation":
    "Lawsuits between individuals or businesses, contract disputes, fraud & misrepresentation, property disputes, defamation, injunctions/restraining orders (non-family), collections & judgment enforcement, monetary-damages disputes",
  "Business / Corporate / Contracts":
    "Business formation (LLCs, corporations, partnerships), operating/shareholder agreements, contract review, breach of contract, partnership disputes, business sales, corporate governance, vendor/customer agreements, NDAs",
  "Labor & Employment":
    "Wrongful termination, discrimination, sexual harassment, retaliation, wage & hour disputes, unpaid wages/overtime, employment contracts, independent-contractor disputes, FMLA/leave issues",
  "Criminal Defense / Post-Conviction":
    "DUI/DWI, misdemeanors & felonies, drug charges, assault/battery, theft/burglary, domestic-violence charges, white-collar crimes, probation/parole violations, appeals, expungement/record clearing",
  "Personal Injury / Insurance":
    "Car/truck/motorcycle accidents, pedestrian/bicycle accidents, slip-and-fall, dog bites, wrongful death, product liability, insurance claim disputes, insurance bad faith, uninsured/underinsured motorist claims",
  "Family Law":
    "Divorce & legal separation, child custody & visitation, child support, spousal support/alimony, property & debt division, prenuptial/postnuptial agreements, paternity, adoption, domestic-violence restraining orders, modification/enforcement of orders, relocation/move-away disputes",
  "Estate Planning / Probate":
    "Wills, living trusts, powers of attorney, advance healthcare directives, probate administration, trust administration, estate disputes, beneficiary disputes, conservatorships",
  Immigration:
    "Green cards/permanent residency, citizenship/naturalization, family-based immigration, employment-based immigration, work visas, student/visitor visas, fiancé visas, asylum/refugee matters, deportation/removal defense, DACA, consular processing",
  "Real Estate / Construction":
    "Buying/selling real estate, landlord-tenant disputes, evictions, lease disputes, boundary/easement disputes, title disputes, HOA disputes, construction contracts & defects, mechanic's liens, zoning/land-use",
  "Bankruptcy / Debt Relief":
    "Chapter 7 bankruptcy, Chapter 13 bankruptcy, debt collection defense, creditor harassment, foreclosure/mortgage debt, repossession, wage garnishment, judgment debt, debt settlement/negotiation, consumer credit issues/credit reporting disputes",
};
